import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { Splatter } from "@/components/Splatter";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="relative min-h-[80vh] flex items-center justify-center px-4 py-16">
      <Splatter />
      <div className="relative w-full max-w-md rounded-2xl border border-[#222] bg-[#0A0A0A]/90 backdrop-blur-xl p-8">
        <div className="text-center"><Logo className="text-2xl" /></div>
        {sent ? (
          <div className="mt-6 text-center">
            <MailCheck className="w-12 h-12 mx-auto text-[#0055FF]" />
            <h1 className="mt-4 font-heading text-xl font-bold">Vérifiez votre boîte mail</h1>
            <p className="mt-2 text-gray-400 text-sm">Si cet e-mail est enregistré, un lien de réinitialisation vous a été envoyé.</p>
            <Link to="/connexion" className="mt-6 inline-block text-[#E6007E] font-bold">Retour à la connexion</Link>
          </div>
        ) : (
          <>
            <h1 className="mt-6 font-heading text-2xl font-bold text-center">Mot de passe oublié</h1>
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
              <div><Label>E-mail</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-black border-white/15 mt-1" required /></div>
              {error && <p className="text-sm text-red-400">{error}</p>}
              <Button data-testid="forgot-submit" type="submit" disabled={loading} className="btn-primary w-full rounded-full py-6 font-bold">
                {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Envoyer le lien"}
              </Button>
            </form>
            <Link to="/connexion" className="mt-4 block text-center text-sm text-gray-400 hover:text-[#E6007E]">Retour à la connexion</Link>
          </>
        )}
      </div>
    </div>
  );
}
